"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CLEAR = exports.REMOVE_FAILED = exports.REMOVE_SUCCESS = exports.REMOVE_REQUEST = exports.TOGGLE_SELECT = exports.FETCH_FAILED = exports.FETCH_SUCCESS = exports.FETCH_REQUEST = exports.SET_USER_SEARCHING_STRING = exports.SELECT_PROJECT = void 0;
exports.SELECT_PROJECT = '@sok/management/projectUsers/SELECT_PROJECT';
exports.SET_USER_SEARCHING_STRING = '@sok/management/projectUsers/SET_USER_SEARCHING_STRING';
exports.FETCH_REQUEST = '@sok/management/projectUsers/FETCH_REQUEST';
exports.FETCH_SUCCESS = '@sok/management/projectUsers/FETCH_SUCCESS';
exports.FETCH_FAILED = '@sok/management/projectUsers/FETCH_FAILED';
exports.TOGGLE_SELECT = '@sok/management/projectUsers/TOGGLE_SELECT';
exports.REMOVE_REQUEST = '@sok/management/projectUsers/REMOVE_REQUEST';
exports.REMOVE_SUCCESS = '@sok/management/projectUsers/REMOVE_SUCCESS';
exports.REMOVE_FAILED = '@sok/management/projectUsers/REMOVE_FAILED';
exports.CLEAR = '@sok/management/projectUsers/CLEAR';
//# sourceMappingURL=projectUsers.js.map